import { render, staticRenderFns } from "./HomeVideoModal.vue?vue&type=template&id=c22512f2&"
import script from "./HomeVideoModal.vue?vue&type=script&lang=js&"
export * from "./HomeVideoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports